intra_module.factory('Trombi', function($resource, api_url, profmanager_url) {

    const transformProfListResponse = function(response, headersGetter, status) {
        if (200 !== status) { return response; }
        return angular.fromJson(response).profs.hits;
    };

    const actions = {
        getTermsForTrombi: {
            method:  'GET',
            url:     `${api_url}/trombi`,
            isArray: false
        },

        getTrombiByTerm: {
            method:  'GET',
            url:     `${api_url}/trombi/:term_id`,
            isArray: false,
            params: {
                term_id: '@term_id'
            }
        },

        getProfs: {
            method:            'GET',
            url:               `${profmanager_url}/profs`,
            isArray:           true,
            transformResponse: transformProfListResponse
        }
    };

    return $resource(`${api_url}/trombi`, { }, actions);
});
